import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function useVisitorTracking() {
  const location = useLocation();
  const sessionRef = useRef(sessionStorage.getItem('vt_sid') || '');

  useEffect(() => {
    const track = async () => {
      try {
        const body = {
          path: location.pathname,
          referrer: document.referrer || '',
          page_title: document.title || '',
          screen_resolution: `${window.screen.width}x${window.screen.height}`,
          language: navigator.language || navigator.userLanguage || '',
        };

        if (sessionRef.current) {
          body.session_id = sessionRef.current;
        }

        const res = await axios.post(`${API}/api/analytics/track`, body).catch(() => null);
        if (res?.data?.session_id && !sessionRef.current) {
          sessionRef.current = res.data.session_id;
          sessionStorage.setItem('vt_sid', res.data.session_id);
        }
      } catch {}
    };
    track();
  }, [location.pathname]);

  // Send heartbeat every 60s so real-time visitor counter works
  useEffect(() => {
    const sid = sessionRef.current || sessionStorage.getItem('vt_sid') || '';
    const sendHeartbeat = () => {
      const currentSid = sessionRef.current || sessionStorage.getItem('vt_sid') || '';
      if (currentSid) {
        axios.post(`${API}/api/visitor/heartbeat`, {
          session_id: currentSid,
          page: location.pathname,
        }).catch(() => {});
      }
    };
    sendHeartbeat();
    const interval = setInterval(sendHeartbeat, 60000);
    return () => clearInterval(interval);
  }, [location.pathname]);
}
